export const READY_TICK_VERSION = 'ready-tick-v1' as const;

/** Match the shared world's 1e-9-second readiness tolerance. Skills admit before
 * their end-of-tick decrement; common dash admits after its decrement. */
export function cooldownReadyTick(previous: number | undefined, remainingS: number, tick: number, tickRate: number, admissionOffset: 0 | 1): number {
  if (remainingS > 1e-9) return tick + Math.ceil((remainingS - 1e-9) * tickRate) + admissionOffset;
  // Preserve natural expiry forever. An early reset changes the deadline once.
  return previous === undefined ? 0 : Math.min(previous, tick + admissionOffset);
}

/** Presentation only; never write a derived countdown back into replication baselines. */
export function remainingCooldownTicks(readyTick: number | undefined, legacyTicks: number | undefined, serverTick: number): number | undefined {
  return readyTick === undefined ? legacyTicks : Math.max(0, readyTick - serverTick);
}
